<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5 class="pull-left">
        Net Change
      </h5>

      <div class="pull-right text-muted" style="padding-top: 5px;">
        Year-to-date
      </div>

      <div class="clearfix"></div>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body text-center">
      <colored-number style="font-size: 36px;" :value="number" :format="format"></colored-number>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import ColoredNumber from '@/components/Numbers/ColoredNumber'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {ColoredNumber, LoadingSpinner},

  mixins: [SaveHeight],

  props: ['year', 'metricType', 'portal', 'user', 'subscriberType'],

  data() {
    return {
      loading: true,
      number: null
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    metricType() {
      this.load()
    },

    portal() {
      this.load()
    },

    user() {
      this.load()
    },

    subscriberType() {
      this.load()
    }
  },

  computed: {
    filters() {
      let filters = []

      if (this.portal && this.portal.length) {
        filters.push({dimension: 'portal_id', operator: 'in', value: this.portal})
      }

      if (this.user) {
        filters.push({dimension: 'user_id', value: this.user})
      }

      if (this.subscriberType) {
        filters.push({dimension: 'subscriber_type', value: this.subscriberType})
      }

      return filters
    },

    startingMetric() {
      return 'starting_subscription_' + this.metricType
    },

    endingMetric() {
      return 'ending_subscription_' + this.metricType
    },

    format() {
      if (this.metricType === 'revenue') {
        return this.$options.filters.price
      }

      return this.$options.filters.number
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      Promise
          .all([this.getStartingRowsPromise(), this.getEndingRowsPromise()])
          .then(responses => {
            let starting = responses[0].data.data[0][this.startingMetric]

            let ending = responses[1].data.data[0][this.endingMetric]

            this.number = starting - ending

            this.loading = false
          })
    },

    getStartingRowsPromise() {
      return http.post('/api/v1/reports/dashboard', {
        start: moment().year(this.year).startOf('year').format('YYYY-MM-DD'),
        end: moment().year(this.year).month(moment().month()).day(moment().day()).format('YYYY-MM-DD'),
        metrics: [this.startingMetric],
        filters: this.filters
      })
    },

    getEndingRowsPromise() {
      return http.post('/api/v1/reports/dashboard', {
        start: moment().year(this.year).startOf('year').format('YYYY-MM-DD'),
        end: moment().year(this.year).month(moment().month()).day(moment().day()).format('YYYY-MM-DD'),
        metrics: [this.endingMetric],
        filters: this.filters
      })
    }
  }
}
</script>